module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.rubric === null) ? _c('span', {
    staticClass: "tag mb-1 mt-1",
    class: {
      'private-tag': _vm.groupTag
    },
    style: ({
      'background-color': '#' + _vm.color
    })
  }, [_c('span', {
    staticClass: "text",
    on: {
      "click": function($event) {
        _vm.toggleTagOptionModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.title) + "\n  ")]), _vm._v(" "), (_vm.showTagOptionModal) ? _c('TagOptionsModal', {
    attrs: {
      "id": _vm.id,
      "color": _vm.color,
      "groupTag": _vm.groupTag,
      "rubric": _vm.rubric,
      "title": _vm.title,
      "owner": _vm.owner,
      "commentID": _vm.commentID
    },
    on: {
      "close": function($event) {
        _vm.showTagOptionModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.removeTag(_vm.id)
      }
    }
  }) : _vm._e()], 1) : _c('span', {
    staticClass: "tags has-addons mb-1 mt-1",
    style: ({
      'background-color': '#' + _vm.color
    })
  }, [_c('span', {
    staticClass: "tag is-rubric"
  }, [_c('RubricIcon')], 1), _vm._v(" "), _c('a', {
    staticClass: "tag",
    style: ({
      'background-color': '#' + _vm.color
    }),
    on: {
      "click": function($event) {
        _vm.toggleRubricItemModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.rubric !== null && _vm.showRubricItemModal) ? _c('RubricItemModal', {
    attrs: {
      "title": _vm.title,
      "ascending": _vm.rubric.ascending,
      "headerA": _vm.rubric.header1,
      "headerB": _vm.rubric.header2,
      "headerC": _vm.rubric.header3,
      "headerD": _vm.rubric.header4,
      "headerE": _vm.rubric.header5,
      "descA": _vm.rubric.desc1,
      "descB": _vm.rubric.desc2,
      "descC": _vm.rubric.desc3,
      "descD": _vm.rubric.desc4,
      "descE": _vm.rubric.desc5,
      "valA": _vm.rubric.val1,
      "valB": _vm.rubric.val2,
      "valC": _vm.rubric.val3,
      "valD": _vm.rubric.val4,
      "valE": _vm.rubric.val5,
      "score": _vm.score,
      "scoreID": _vm.scoreID,
      "commentID": _vm.commentID,
      "tagID": _vm.id,
      "videoID": _vm.videoID,
      "rubricID": _vm.rubric.id,
      "color": _vm.color,
      "owner": _vm.owner
    },
    on: {
      "close": function($event) {
        _vm.showRubricItemModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('button', {
    staticClass: "delete is-rubric",
    on: {
      "click": function($event) {
        _vm.removeTag(_vm.id)
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-34b69d70"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tag.vue
// module id = 1004
// module chunks = 0